module.exports = __webpack_public_path__ + "static/media/Slomo-Throwing-Short-6.2e241dc1.m4v";